import * as React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./Tooltip";

interface TooltipWrapperProps {
  title: string;
  arrow?: boolean;
  children: React.ReactElement;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
}

/**
 * A wrapper around the Radix UI Tooltip that provides a simpler API
 * similar to Material-UI's Tooltip component.
 */
const TooltipWrapper = React.forwardRef<HTMLDivElement, TooltipWrapperProps>(
  ({ title, arrow = false, children, side = "top", align = "center" }, ref) => {
    const [open, setOpen] = React.useState<boolean>(false);

    const childWithClick = React.useMemo(() => {
      const originalOnClick = (children as any).props?.onClick as ((e: React.MouseEvent) => void) | undefined;
      return React.cloneElement(children, {
        onClick: (e: React.MouseEvent) => {
          if (typeof originalOnClick === "function") {
            originalOnClick(e);
          }
          setOpen((prev) => !prev);
        }
      });
    }, [children]);

    return (
      <TooltipProvider>
        <Tooltip open={open} onOpenChange={setOpen}>
          <TooltipTrigger asChild>
            {childWithClick}
          </TooltipTrigger>
          <TooltipContent ref={ref} side={side} align={align}>
            {title}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
);

TooltipWrapper.displayName = "TooltipWrapper";

export default TooltipWrapper;